import { useStore } from '@modules';
import { BaseCurrencyEnum, CryptoCurrencyEnum, BaseNetworkEnum } from '@modules/global/types';

export type UseCurrencyBase = () => {
  getBaseCurrency: (currency: CryptoCurrencyEnum) => BaseCurrencyEnum | undefined;
  getBaseNetwork: (currency: CryptoCurrencyEnum) => BaseNetworkEnum | undefined;
};

const useCurrencyBase: UseCurrencyBase = () => {
  const [{ global }] = useStore();
  const { base } = global.currencies.config;

  const getBaseCurrency = (currency: CryptoCurrencyEnum) => base[currency];

  const getNetworks = (currency: CryptoCurrencyEnum) => [
    {
      name: BaseNetworkEnum['ERC-20'],
      condition:
        currency !== CryptoCurrencyEnum.ETH && getBaseCurrency(currency) === BaseCurrencyEnum.ETH,
    },
    {
      name: BaseNetworkEnum['BEP-20'],
      condition:
        currency !== CryptoCurrencyEnum.BNB && getBaseCurrency(currency) === BaseCurrencyEnum.BNB,
    },
    {
      name: BaseNetworkEnum.BSC,
      condition: currency === CryptoCurrencyEnum.BNB,
    },
    {
      name: BaseNetworkEnum['TRC-20'],
      condition: currency === CryptoCurrencyEnum.USDC,
    },
  ];

  const getBaseNetwork = (currency: CryptoCurrencyEnum) =>
    getNetworks(currency).find(network => network.condition)?.name;

  return { getBaseCurrency, getBaseNetwork };
};

export default useCurrencyBase;
